import apiClient from './client';

const normalizeCampaignPayload = (data) => {
  if (!data) return data;
  if (typeof FormData !== 'undefined' && data instanceof FormData) return data;
  if (typeof data === 'number' || typeof data === 'string') {
    const id = Number(data);
    return { campaign_id: Number.isNaN(id) ? data : id };
  }
  if (typeof data === 'object') {
    const payload = { ...data };
    if (payload.campaign_id == null && payload.campaignId != null) {
      payload.campaign_id = payload.campaignId;
    }
    if (payload.scheduled_at == null && payload.scheduledAt != null) {
      payload.scheduled_at = payload.scheduledAt;
    }
    return payload;
  }
  return data;
};

export const broadcastApi = {
  // Broadcast Campaign APIs
  create: (data) => {
    const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;
    return apiClient.post(
      '/api/broadcast-campaigns',
      data,
      isFormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : undefined
    );
  },
  getCampaigns: (params) => apiClient.get('/api/broadcast-campaigns', { params }),
  getById: (id) => apiClient.get(`/api/broadcast-campaigns/${id}`),
  send: (data) => apiClient.post('/api/broadcast-campaigns/send', normalizeCampaignPayload(data)),
  schedule: (data) => apiClient.post('/api/broadcast-campaigns/schedule', normalizeCampaignPayload(data)),
  cancel: (data) => apiClient.post('/api/broadcast-campaigns/cancel', normalizeCampaignPayload(data)),
  cancelSchedule: (data) => apiClient.post('/api/broadcast-campaigns/cancel', normalizeCampaignPayload(data)),
  getRecords: (id, params) => apiClient.get(`/api/broadcast-campaigns/${id}/records`, { params }),
  getAllRecords: (params) => apiClient.get('/api/broadcast-campaigns/all/records', { params }),
  getScheduleHistory: (params) => apiClient.get('/api/broadcast-campaigns', { params }),
  deleteCampaign: (id) => apiClient.delete(`/api/broadcast-campaigns/${id}`),

  // Broadcast Group APIs
  getAll: (params) => apiClient.get('/api/broadcast-groups', { params }),
  getGroups: (params) => apiClient.get('/api/broadcast-groups', { params }),
  getGroupById: (id) => apiClient.get(`/api/broadcast-groups/${id}`),
  createGroup: (data) => apiClient.post('/api/broadcast-groups', data),
  update: (id, data) => apiClient.put(`/api/broadcast-groups/${id}`, data),
  updateGroup: (id, data) => apiClient.put(`/api/broadcast-groups/${id}`, data),
  delete: (id) => apiClient.delete(`/api/broadcast-groups/${id}`),
  deleteGroup: (id) => apiClient.delete(`/api/broadcast-groups/${id}`),

  // Recipients
  addRecipients: (id, data) => apiClient.post(`/api/broadcast-groups/${id}/recipients`, data),
  addRecipientsBulk: (id, data) => apiClient.post(`/api/broadcast-groups/${id}/recipients/bulk`, data),
  getRecipients: (id) => apiClient.get(`/api/broadcast-groups/${id}/recipients`),
  deleteRecipient: (groupId, recipientId) =>
    apiClient.delete(`/api/broadcast-groups/${groupId}/recipients/${recipientId}`),
  uploadRecipientsCsv: (id, formData) =>
    apiClient.post(`/api/broadcast-groups/${id}/recipients/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
};

export default broadcastApi;
